import React from 'react'
import CustomTable, { TableColumn } from '../table/table'
import { CanBeAnything } from '../../../types'

export interface AnalyzeData {
  keyName: string
  delivered: number | string
  scheduled: number | string
}

interface AnalayzeTableProps {
  analyzeData: CanBeAnything
  isLoading: boolean
}

const cols: TableColumn[] = [
  {
    key: 'keyName',
    label: 'Report',
    flexGrow: 1,
  },
  {
    key: 'delivered',
    label: 'Delivered',
    flexGrow: 1,
  },
  {
    key: 'scheduled',
    label: 'Scheduled',
    flexGrow: 1,
  },
]

export const AnalyzeTable = ({ analyzeData, isLoading }: AnalayzeTableProps) => {
  return <CustomTable data={analyzeData} columns={cols} isLoading={isLoading} />
}
